import { cn } from "@/lib/utils";
import { bucketUrlPrefix } from "common/config";
import { useState } from "react";
import Slider from "react-slick";
import { useI18N } from "common/hooks";
import { ChevronDown } from "lucide-react";
import { PiFlagPennant } from "react-icons/pi";
import { formatDateShort } from "common/utils/general";

const SafeSlider = Slider as any; 

function SampleNextArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      role="button"
      className="absolute right-1/2 translate-x-[calc(100%+4px)] bottom-4 border rounded-full"
      onClick={onClick}
    >
      <img className="w-8 h-8" src="/images/Main Icon Buttons (1).svg" alt="" />
    </div>
  );
}

function SamplePrevArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      role="button"
      className="absolute bottom-4 left-1/2 -translate-x-[calc(100%+4px)] z-10 border rounded-full"
      onClick={onClick}
    >
      <img className="w-8 h-8" src="/images/Main Icon Buttons.svg" alt="" />
    </div>
  );
}

type AccessibilitySubItemHybridProps = {
  venueId: string;
  pageChildrenCategoryName: string;
  levelOption: any;
  fullSize?: boolean;
  onFlag: (mainTag) => void;
  lastUpdated: string;
};

function AccessibilitySubItemHybrid({
  pageChildrenCategoryName,
  levelOption,
  fullSize,
  onFlag,
  lastUpdated,
}: AccessibilitySubItemHybridProps) {
  const photos = levelOption.levelPhotos;

  const [expanded, setExpanded] = useState(false);
  const i18n = useI18N();

  return (
    <div className="bg-primary-100 dark:bg-[#37354D] rounded-[12px] px-[14px] md:px-[18px] py-[10px] md:py-[18px]">
      <div
        onClick={() => {
          setExpanded(!expanded);
        }}
        className="cursor-pointer flex flex-row items-center"
        tabIndex={0}
      >
        {!expanded && photos && photos.length > 0 && (
          <img
            src={bucketUrlPrefix + photos[0].path}
            className="w-[100px] md:w-[100px] h-[100px] rounded-[12px] object-cover"
            aria-hidden="true"
          />
        )}
        <div className="flex flex-col ml-4 flex-1">
          <div className="desktop-h3-small-semi-bold text-primary-800 dark:text-primary-150">
            {pageChildrenCategoryName}
          </div>
          <div className="mt-2 mobile-h3-small-semi-bold text-primary-800 dark:text-primary-150">
            {levelOption.level}
          </div>
        </div>
        <div className="sm:mr-1 md:mr-4">
          <button
            className={cn(
              "text-primary-800 dark:text-primary-150 ml-2 duration-200",
              expanded ? "rotate-180" : ""
            )}
            aria-label={`${expanded ? "Close" : "Open"} ${pageChildrenCategoryName} accessibility tags`}
          >
            <ChevronDown aria-hidden="true" role="none" />
          </button>
        </div>
      </div>
      {expanded && (
        <div>
          <div
            className={cn("my-4 pb-6", fullSize ? "" : " max-w-[100%]")}
            aria-hidden="true"
          >
            <SafeSlider
              dots={true}
              speed={500}
              slidesToShow={1}
              slidesToScroll={1}
              dotsClass="slick-dots custom-dots"
              className="custom-slider"
              nextArrow={photos.length > 1 && <SampleNextArrow />}
              prevArrow={photos.length > 1 && <SamplePrevArrow />}
              infinite={photos.length > 1}
              arrows={photos.length > 1}
            >
              {photos.map((image, index) => (
                <div
                  key={index}
                  className={cn(
                    "rounded-2xl overflow-clip max-h-[200px] w-[100%]",
                    fullSize ? "md:max-h-[350px]" : "md:max-h-[250px]"
                  )}
                  onClick={() => {}}
                >
                  <img
                    className={cn(
                      "rounded-2xl overflow-clip max-h-[200px] object-cover w-full",
                      fullSize ? "md:max-h-[350px]" : "md:max-h-[250px]"
                    )}
                    src={bucketUrlPrefix + image.path}
                    alt={image.altText}
                  />
                </div>
              ))}
            </SafeSlider>
          </div>
          <div className="rounded-[12px] bg-white dark:bg-primary-900 py-3 px-2">
            {levelOption.questionOptions.map(
              (questionOption, questionIndex) => (
                <div key={questionIndex} className="">
                  <ul className="list-disc px-6 mb-2">
                    {questionOption.tagOptions.map((tagOption, tagIndex) => (
                      <li
                        className="paragraph-medium-regular text-primary-800 dark:text-primary-150 my-1"
                        key={tagIndex}
                      >
                        {tagOption.optionTitle}
                      </li>
                    ))}
                  </ul>
                </div>
              )
            )}
          </div>
          <div className="rounded-[12px] bg-primary-50 dark:bg-dark-800 flex mt-3 border-2 border-primary-200 dark:border-primary-300">
            <div className="p-2 flex flex-row items-center justify-between w-[100%]">
              <div className="ml-4">{`${i18n.get("lastUpdated")}: ${formatDateShort(lastUpdated)}`}</div>
              {/* <div
                onClick={() => onFlag(pageChildrenCategoryName)}
                className="cursor-pointer flex flex-row justify-center items-center w-[50px] h-[50px] rounded-[12px] border-2 border-error-900 dark:border-error-200 bg-primary-50 dark:bg-dark-800"
                tabIndex={0}
                role="button"
                aria-label="Flag accessibility"
              >
                <PiFlagPennant
                  size={24}
                  className="text-error-900 dark:text-error-200"
                  aria-hidden="true"
                />
              </div> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccessibilitySubItemHybrid;
